module.exports = __webpack_public_path__ + "img/0-88.267dc300.jpg";